const Request = {
  DBInfo: "/Tables/APIUsageReport/Info",
  List: "/Tables/APIUsageReport/List",
  Info: "/Tables/APIUsageReport/Get",
  Add: "/Tables/APIUsageReport/Add",
  Delete: "/Tables/APIUsageReport/Delete",
  Edit: "/Tables/APIUsageReport/Edit",
  Export: "/Tables/APIUsageReport/Export",
};

let exports = {
  Request,
};

export default exports;
